<template>
    <div class="kpi-simple-card chart-responsive">
        <div class="kpi-header">
            <h2 style="color: #437EBE; font-size: 1.5em;">
                {{ title }}
            </h2>
    
            <v-spacer></v-spacer>
    
            <Dropdown
                :value="exportTest"
                :options="exportOptions"
                @input="onExportOptionSelected"
                placeholder="Exportar"
                class="chart-type-select"
                style="min-width: 180px; max-width: 220px;"
            />
<!--             <Dropdown
            v-model="chartType"
            :options="chartTypeOptions"
            class="chart-type-select"
            style="min-width: 180px; max-width: 220px;"
            /> -->
        </div>

        <div class="chart-container">
            <canvas :id="canvaID"></canvas>
            <v-progress-circular v-if="loading" indeterminate color="primary"
                style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)" />
            </div>
            <div style="text-align:center; width: 100%;margin-top: 10px">
              <span style="color: #696969; font-weight: bold; font-size: 14px;">{{ subtitle }}</span>
            </div>
    </div>
</template>

<script>
import Chart from "chart.js";
import goalLinePlugin from '../../pages/Consumption/ChartsConsumption/goalLinePlugin'
import Dropdown from '@/components/DropMenus/Dropdown.vue'

export default {
    name: "ConsumptionBarChart",
    props: {
        title: { type: String, default: null },
        subtitle: { type: String, default: null },
        labels: { type: Array, default: () => [] },
        datasets: { type: Array, default: () => [] },
        average: { type: Number, default: 0 },
        loading: { type: Boolean, default: false },
        showGoalLine: { type: Boolean, default: true },
    },
    components: {
        Dropdown
    },
    data() {
        return {
            id: null,
            canvaID: null,
            myChart: null,
            colorBar: "#3474cb",
            colorBarAlt: "#697e9d",
            colorLineAverage: "#2b82ff",
            gradientBg: null,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                showGoalLine: true,
                plugins: {
                    datalabels: { display: false },
                },
                legend: {
                    display: true,
                    labels: { usePointStyle: true },
                },
                title: {
                    display: false,
                },
                scales: {
                    yAxes: [{
                        ticks: { beginAtZero: true },
                        gridLines: { display: true }
                    }],
                    xAxes: [{
                        gridLines: { display: false }
                    }]
                },
            },
            data: {
                labels: [],
                datasets: [],
            },
            exportTest: null,
            exportOptions: [
                { text: 'PDF', value: 'pdf' },
                { text: 'Planilha', value: 'spreadsheet' },
            ],
            chartType:"bar",
            chartTypeOptions:[
            { text: 'Barra', value: 'bar' },
            { text: 'Linha', value: 'line' },
            { text: 'Planilha', value: 'sheet' },
            ],
        };
    },
    created() {
        this.id = this._uid;
        this.canvaID = `consumption-bar-chart-${this.id}`;
    },
    mounted() {
        Chart.plugins.register(goalLinePlugin);
        this.$nextTick(() => {
            this.render();
        });
    },
    methods: {
        normalizeDatasets(datasets = []) {
            return datasets.map((dataset) => ({
                ...dataset,
                hidden: dataset.type === 'line' ? !this.showGoalLine : dataset.hidden,
                extendedBorderWidth: dataset.type === 'line' ? (dataset.borderWidth || 2) : undefined,
                borderWidth: dataset.type === 'line' ? 0 : dataset.borderWidth,
            }));
        },
        buildExtendedAverageLinePlugin() {
            return {
                id: `extended-average-line-${this.id}`,
                afterDatasetsDraw: (chart) => {
                    const { ctx } = chart;
                    const xAxis = chart.scales['x-axis-0'];

                    if (!xAxis || chart?.options?.showGoalLine === false) return;

                    chart.data.datasets.forEach((dataset, index) => {
                        const meta = chart.getDatasetMeta(index);
                        const isVisible = typeof chart.isDatasetVisible === 'function'
                            ? chart.isDatasetVisible(index)
                            : meta?.hidden !== true;

                        if (dataset.type !== 'line' || dataset.hidden || meta?.hidden === true || !isVisible) return;

                        const points = meta?.data || [];
                        const visiblePoints = points.filter((point) => !point?._model?.skip);

                        if (!visiblePoints.length) return;

                        ctx.save();
                        ctx.strokeStyle = dataset.borderColor || '#0E76BC';
                        ctx.lineWidth = dataset.extendedBorderWidth || dataset.borderWidth || 2;
                        ctx.setLineDash(Array.isArray(dataset.borderDash) ? dataset.borderDash : []);
                        ctx.globalAlpha = dataset.lineOpacity || 1;
                        ctx.lineCap = 'round';
                        ctx.lineJoin = 'round';
                        ctx.beginPath();

                        const firstPoint = visiblePoints[0]._model;
                        const lastPoint = visiblePoints[visiblePoints.length - 1]._model;

                        ctx.moveTo(xAxis.left, firstPoint.y);

                        visiblePoints.forEach((point) => {
                            ctx.lineTo(point._model.x, point._model.y);
                        });

                        ctx.lineTo(xAxis.right, lastPoint.y);
                        ctx.stroke();
                        ctx.restore();
                    });
                }
            };
        },
        render(datasets = this.datasets) {
            const normalizedDatasets = this.normalizeDatasets(datasets);

            if (this.myChart) {
                this.myChart.data.labels = this.labels;
                this.myChart.data.datasets = normalizedDatasets;
                if (this.myChart.options) {
                    this.myChart.options.showGoalLine = this.showGoalLine;
                }
                this.myChart.update();
                return;
            }
            const canvas = document.getElementById(this.canvaID);
            if (!canvas) return; // Protege contra null
            const ctx = canvas.getContext && canvas.getContext('2d');
            if (!ctx) return; // Protege contra null
            this.options.showGoalLine = this.showGoalLine;
            this.myChart = new Chart(ctx, {
                type: "bar",
                data: {
                    labels: [...this.labels],
                    datasets: normalizedDatasets,
                },  
                options: this.options,
                plugins: [this.buildExtendedAverageLinePlugin()]
            });
        },
        onExportOptionSelected(value) {
            if (value === 'pdf') {
                this.exportPDF();
            } else if (value === 'spreadsheet') {
                this.exportSpreadsheet();
            }
            this.exportTest = null;
        },
        exportPDF() {
            this.$emit('export-pdf');
        },
        exportSpreadsheet() {
            this.$emit('export-sheet');
        },
    },
    watch: {
        datasets: {
            immediate: true,
            deep: true,
            handler(newValue) {
                this.$nextTick(() => {
                    if (this.myChart) {
                        this.myChart.data.datasets = this.normalizeDatasets(newValue);
                        this.myChart.update();                    
                    } else {
                        this.render([...newValue]);
                    }
                });
            },
        },
        labels: {
            immediate: true,
            deep: true,
            handler(newValue) {
                this.$nextTick(() => {
                    if (this.myChart) {
                        this.myChart.data.labels = [...newValue];
                        this.myChart.update();             
                    } else {
                        this.render(this.datasets);
                    }
                });
            },
        },
        showGoalLine() {
            this.$nextTick(() => {
                if (this.myChart) {
                    this.myChart.options.showGoalLine = this.showGoalLine;
                    this.myChart.data.datasets = this.normalizeDatasets(this.datasets);
                    this.myChart.update();
                } else {
                    this.render(this.datasets);
                }
            });
        },
    },
};
</script>

<style scoped>
.kpi-simple-card {
    background: #fff;
    border: 1.5px solid #e0e3ea;
    border-radius: 12px;
    padding: 18px 20px 14px 20px;
    min-width: 180px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-right: 16px;
    height: 100%;
}
.kpi-header{
    gap: 16px;
}
.chart-responsive {
    height: 100%;
    min-height: 300px;
}
.chart-container {
    position: relative;
    width: 100%;
    height: 100%;
}
.chart-title {
    position: absolute;
    top: 15px;
    left: 15px;
    z-index: 2;
}
canvas {
    width: 100% !important;
    height: 100% !important;
    display: block;
}
</style>
